import { ValidatorFn } from '@angular/forms';

export class PersonValidators {
  static realName(): ValidatorFn {
    return (control) => {
      const value = control.value ?? '';

      if (!/^[\w \t.,_-]*$/.test(value)) {
        return {
          invalidCharacters:
            'Forbidden characters found. Allowed characters are: [A-Z a-z 0-9 . , _ - SPACE]',
        };
      }

      if (value && value.length < 3) {
        return {
          realNameLength: 'Real Name is required to be at least 3 characters!',
        };
      }

      return null;
    };
  }
}
